<template>
  <v-col cols="12" class="pb-0 pl-0">
    <span class="txtLabel"> {{ title }}</span>
    <v-row>
      <v-col cols="4">
        <input-phone
          v-model="model.telefoneCelular"
          :label="cel ? 'Telefone celular' : 'Telefone'"
          :cel="cel"
          :tel="tel"
          required
          :disabled="disabled"/>
      </v-col>
      <v-col cols="8">
        <input-email
          v-model="model.email"
          label="E-mail"
          required
          :disabled="disabled"/>
      </v-col>
    </v-row>
  </v-col>
</template>
<script>
export default {
  props: {
    value: null,
    disabled: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: 'Dados de contato'
    },
    tel: {
      type: Boolean,
      default: false
    },
    cel: {
      type: Boolean,
      default: true
    },
  },
  computed: {
    model: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      },
    },
  },
  methods: {
  },

}
</script>
<style scoped>
  .txtLabel{
    font-weight: 600;
    font-size: 16px;
    margin:0 12px;
  }
</style>
